import { registerPlugin } from '@capacitor/core';
const NativeBiometric = registerPlugin('NativeBiometric', {
    web: () => import('./web').then((m) => new m.NativeBiometricWeb()),
});
// Web CI packed-example verify installs the published tarball instead of file:../.
export * from './definitions';
export { NativeBiometric };
//# sourceMappingURL=index.js.map